// SR-CUSTOM: Block variant resolution until ALL options are selected.
//
// Shopify's Section Rendering API resolves ?option_values=X to the first
// available variant matching the partial selection. With only Size chosen,
// Detail Finish auto-fills with Brass, which then re-renders the picker with
// Brass checked and swaps the gallery to the variant image. We intercept the
// change event in the capture phase and stopImmediatePropagation() so that
// VariantSelects.onVariantChange never runs on partial selections. The hero
// image, "From $X" price, and "Choose size and finish" button all stay put.

(function () {
  function isPartialSelection(variantSelects) {
    var groups = variantSelects.querySelectorAll('fieldset, select');
    var selected = variantSelects.querySelectorAll('select option[selected], fieldset input:checked');
    return selected.length < groups.length;
  }

  function setChooseState(variantSelects) {
    var section = variantSelects.dataset.section;
    if (!section) return;
    var ids = [
      'product-form-' + section,
      'product-form-' + section + '-product-buy-bar'
    ];
    ids.forEach(function (id) {
      var form = document.getElementById(id);
      if (!form) return;
      var btn = form.querySelector('[name="add"]');
      var btnText = form.querySelector('[name="add"] > span');
      if (btn) btn.setAttribute('disabled', 'disabled');
      if (btnText) btnText.textContent = 'Choose size and finish';
    });
    if (variantSelects.dataset.updateUrl !== 'false' && window.history && window.history.replaceState) {
      try {
        window.history.replaceState({}, '', variantSelects.dataset.url);
      } catch (err) { /* noop */ }
    }
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var variantSelects = target.closest('variant-selects');
    if (!variantSelects) return;
    if (!isPartialSelection(variantSelects)) return;

    // Block VariantSelects.onVariantChange from firing.
    e.stopImmediatePropagation();
    setChooseState(variantSelects);
  }, true); // capture: true — runs before the bubble-phase listener inside <variant-selects>
})();
